export const isOnSale = (variants, currency) =>
  !!variants.find(variant => {
    const { compareAtPrice, price } = variant.presentmentPrices
      ? variant.presentmentPrices.find(
          ({ price }) => price && price.currencyCode === currency
        )
      : variant;

    return (
      compareAtPrice !== null &&
      parseFloat(price.amount) < parseFloat(compareAtPrice.amount)
    );
  });
